import { render, staticRenderFns } from "./FilterFileType.vue?vue&type=template&id=4f6510cc&"
import script from "./FilterFileType.vue?vue&type=script&lang=ts&"
export * from "./FilterFileType.vue?vue&type=script&lang=ts&"
import style0 from "./FilterFileType.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports